import {ActivityChat} from './ActivityChat';
export default ActivityChat;
